export default __webpack_public_path__ + "static/media/mdtcLogoW.e9d6ae09.png";